module.exports = __webpack_public_path__ + "assets/img/thumb-Kitome-Testimonials-Video.39ebf8ef.jpg";